import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=43a3e4e8&"
import script from "./Notifications.vue?vue&type=script&lang=ts&"
export * from "./Notifications.vue?vue&type=script&lang=ts&"
import style0 from "./Notifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43a3e4e8')) {
      api.createRecord('43a3e4e8', component.options)
    } else {
      api.reload('43a3e4e8', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=43a3e4e8&", function () {
      api.rerender('43a3e4e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Notifications.vue"
export default component.exports